// extracted by mini-css-extract-plugin
module.exports = {"card":"Card-module--card--TB1T6","press":"Card-module--press--3j4Hk"};